import React, { Component } from "react";
import _ from "lodash";
import moment from 'moment';
import {
  string,
  object,
  oneOfType,
  array,
  instanceOf,
  func,
  objectOf,
  arrayOf,
  any,
  bool,
  number,
  shape,
} from "prop-types";
import { setChartSelector } from '../../../state/modules/app/campaign';
import {
  DAYPART_COMPILATION_CHART_ID,
  COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE,
} from "../../../helpers/constant";
import DaypartDetailsViewerComponent from '../../DaypartElements/DaypartDetailsViewer';
import ShowAllAds from '../../Modal/ShowAllAds';
import { advertiserShape } from '../../../helpers/propTypes';
import { dayOfWeek } from 'components/DashboardTab/preprocessData';
import {
  SINGLE_PAGE_WEB_ANALYTICS_DATA,
  MIN_LENGTH_DAYPART_DATA,
  newAdUsersMetricKey
} from '../../../helpers/constant';
import {
  getEarlistDate,
  getLatestDate
} from '../../../helpers/formatData';
import { shouldShowTabDisclaimer, shouldShowTileByDateCompare } from '../../../helpers/common';
import cx from 'classnames';

import styles from "./styles.scss";

export const defaultChartSelector = { "type": "adVisit", "timeRange": "byDayPart", showBaseSerie: true, showAdditionSerie: true, showGuidelineSeries: true };
export const dataKeys = {
    adVisit: {
      baseValueKey: 'nonAdVisit',
      additionalValueKey: 'adVisit'
    },
    newAdUsers: {
      baseValueKey: 'nonNewAdUsers',
      additionalValueKey: 'newAdUsers'
    }
};

export function formattedChartData(typeSelector, compilationChartData) {
  let dataSet = _.cloneDeep(compilationChartData);
  const { baseValueKey, additionalValueKey } = dataKeys[typeSelector];

  dataSet = compilationChartData && compilationChartData.reduce((acc, currentEntry) => {
    const { time, ads } = currentEntry;
    acc.push({
      time,
      guidelineValue: ads,
      baseValue: currentEntry[baseValueKey],
      additionalValue: currentEntry[additionalValueKey]
    })
    return acc;
  }, []);
  return dataSet;
}

class DaypartAnalytics extends Component {
  static propTypes = {
    chartData: oneOfType([object, string, array]),
    campaign: instanceOf(Object),
    chartSelector: objectOf(objectOf(string)),
    daypartChartSelectors: arrayOf(objectOf(string)),
    range: string,
    setChartSelector: func,
    urlApi: objectOf(string),
    advertiser: advertiserShape,
    notifications: arrayOf(any),
    inpdf: bool,
    page: number,
    pageNumber: number,
    isCustomReport: bool,
    showInReportConfig: shape({
      daypartAnalyticsChart: bool,
      daypartAnalyticsTable: bool
    }),
    countInReportConfig: shape({
      daypartAnalyticsChart: arrayOf(number),
      daypartAnalyticsTable: arrayOf(number),
    }),
    setReportChartSelector: func,
    tableSortSelector: shape({
      sortKey: string,
      sortType: string,
    }),
    setReportTableSortSelector: func,
    enabledFlags: arrayOf(string),
    isHiddenChart: bool,
    isHiddenTable: bool,
    isTableOnly: bool,
    rowOnFirstPage: number
  }

  static defaultProps = {
    countInReportConfig: {
      daypartAnalyticsChart: [1],
      daypartAnalyticsTable: [1],
    },
  }

    state = {
      openDrillDown: false,
      detailUrl: {},
      detailInfo: {}
    }

    handleSetChartSelector = (chartId, updateSelector, selectorIndex) => {
      const {
        campaign,
        setChartSelector,
        setReportChartSelector,
        isCustomReport,
        setReportTableSortSelector,
      } = this.props;
      const campaignId = campaign && campaign.campaign_id;
      setChartSelector && setChartSelector(campaignId, chartId, updateSelector);
      isCustomReport && setReportChartSelector && setReportChartSelector(chartId, selectorIndex, updateSelector);
      // reset table sort selector when changing chart selector
      setReportTableSortSelector && setReportTableSortSelector(chartId, selectorIndex, undefined);
    }

    formattedChartData(typeSelector, compilationChartData) {
      let dataSet = _.cloneDeep(compilationChartData);
      const { baseValueKey, additionalValueKey } = dataKeys[typeSelector];

      dataSet = compilationChartData && compilationChartData.reduce((acc, currentEntry) => {
        const { time, ads } = currentEntry;
        acc.push({
          time,
          guidelineValue: ads,
          baseValue: currentEntry[baseValueKey],
          additionalValue: currentEntry[additionalValueKey]
        })
        return acc;
      }, []);
      return dataSet;
    }

    handleTableCellClick = (data, chartId) => {
      const { urlApi, chartSelector, campaign, isCustomReport } = this.props;
      if (isCustomReport) {
        return;
      }
      const timeRange = _.get(chartSelector, [chartId, 'timeRange'], 'byDayPart');
      const { timeWithYear, time } = data;
      const detailUrl = {
        urlApi,
        campaignId: campaign.campaign_id,
        usedTimezone: false
      }

      switch (timeRange) {
        case 'daily':
          detailUrl.startDate = moment(timeWithYear, 'MM/DD/YYYY');
          detailUrl.endDate = moment(timeWithYear, 'MM/DD/YYYY');
          break;
        case 'weekly':
          {
            const timeArr = timeWithYear.split(/[ -]+/);
            detailUrl.startDate = new Date(timeArr[0]);
            detailUrl.endDate = new Date(timeArr[1]);
            break;
          }
        case 'monthly':
          {
            const {
              start: campaignStart,
              end: campaignEnd
            } = _.get(campaign, 'masterCalendar.selected', {});
            const date = new Date(time);
            const monthStart = moment(date).startOf('month');
            const monthEnd = moment(date).endOf('month');
            detailUrl.startDate = getLatestDate([monthStart, campaignStart]);
            detailUrl.endDate = getEarlistDate([monthEnd, campaignEnd]);
            break;
          }
        case 'hourly':
          {
            detailUrl.hours = time;
            break;
          }
        case 'byDayPart':
          {
            detailUrl.dayPartRange = time;
            break;
          }
        case 'byDayOfWeek':
          {
            detailUrl.dayOfWeek = time;
            break;
          }
        }

      this.setState({
        chartId,
        openDrillDown: true,
        detailUrl,
        detailInfo: { ...detailUrl }
      });
    }

    processMentionListByDayPart = (mention) => {
      const regex = /\(([^)]+)\)/;
      const dayPartRange = _.get(this.state, 'detailUrl.dayPartRange', '');
      const range = regex.exec(dayPartRange);
      const { daypart_datetime: daypartDateTime } = mention;
      const rangeArr = range[1].split('-');
      const dateTime = moment(daypartDateTime);
      const time = moment({
        hours: dateTime.hours(),
        minutes: dateTime.minutes(),
        seconds :dateTime.seconds()
      });
      const start = moment(rangeArr[0], 'ha').startOf('hour');
      const end = moment(rangeArr[1], 'ha').startOf('hour');
      if (start.isAfter(end)){
        end.add(1, 'days');
      }
      const isMatching = time.isBetween(start, end);
      if (isMatching) {
        return mention;
      }
      //else, do nothing, ShowAllAds will check mention data and remove if necessary
    }

    processMentionListByDayOfWeek = (mention) => {
      const { detailUrl } = this.state;
      const { daypart_datetime: daypartDateTime } = mention;
      const currentDayOfWeek = _.get(detailUrl, 'dayOfWeek');
      const weekday = moment(daypartDateTime).weekday();
      const isMatching = dayOfWeek.indexOf(currentDayOfWeek) == weekday;
      if (isMatching) {
        return mention;
      }
      //else, do nothing, ShowAllAds will check mention data and remove if necessary
    }

    handleCloseDrillDown = () => {
      this.setState({
        openDrillDown: false,
        detailInfo: {}
      });
    }
    //else, do nothing, ShowAllAds will check mention data and remove if necessary


    get handleAnalyzeMention() {
      const { chartId } = this.state;
      const { chartSelector } = this.props;
      const timeRange = _.get(chartSelector, [chartId, 'timeRange']);
      if (chartId !== DAYPART_COMPILATION_CHART_ID) {
        return;
      }
      if ( timeRange === 'byDayPart') {
        return this.processMentionListByDayPart;
      } else if (timeRange === 'byDayOfWeek') {
        return this.processMentionListByDayOfWeek;
      }
    }
    //else, do nothing, ShowAllAds will check mention data and remove if necessary

    render() {
      const {
        chartData,
        campaign,
        range,
        advertiser,
        notifications,
        inpdf,
        page,
        pageNumber,
        isCustomReport,
        countInReportConfig,
        daypartChartSelectors,
        tableSortSelector,
        enabledFlags,
        reportBuilder,
        isHiddenChart,
        isHiddenTable,
        isTableOnly,
        rowOnFirstPage
      } = this.props;
      const { openDrillDown, detailUrl, detailInfo, chartId } = this.state;
      const daypartDetailSelector = _.get(campaign, ["chartSelector", DAYPART_COMPILATION_CHART_ID], defaultChartSelector);
      const typeSelector = daypartDetailSelector.type;
      const timeRangeSelector = daypartDetailSelector.timeRange;
      const compilationChartData = _.get(chartData, [DAYPART_COMPILATION_CHART_ID, "data", timeRangeSelector]);
      const daypartChartData = this.formattedChartData(typeSelector, compilationChartData);
      
      const isGrandTotalDisplay = !inpdf || inpdf && page === pageNumber - 1;
      const isDaypartTab = !inpdf || (inpdf && page === 0);
      const { daypartAnalyticsChart: chartCount, daypartAnalyticsTable: tableCount } = countInReportConfig;
      const daypartChartAndTableCount = getNumberOfChartAndTableInReport(chartCount, tableCount);
      const customReportDateRange = _.get(reportBuilder, 'reportProperties.reportDateRange');
      const isNewAdUserSelectorShow =  isCustomReport ? 
                                      shouldShowTileByDateCompare({advertiser, campaign, customReportDateRange}) :
                                      shouldShowTileByDateCompare({advertiser, campaign});
      const isNewAdUsersEnabled = checkEnableFeatureFlag(enabledFlags, [newAdUsersMetricKey]) && isNewAdUserSelectorShow;
      const ga4CutOverDate = _.get(advertiser, 'google_analytics_cutover_date');
      const isInGA4Dates = isCustomReport ? 
                           shouldShowTabDisclaimer({ advertiser, campaign, customReportDateRange}) :
                           shouldShowTabDisclaimer({ advertiser, campaign });

      let tableRowsPerPage = 0;
      return(
        <div>
          {Array(daypartChartAndTableCount).fill('').map((_item, index) => {
            const customShowInReportConfig = {
              daypartAnalyticsChart: !!chartCount.find(item => item === index + 1) && (inpdf ? (!isHiddenChart || isTableOnly) : true),
              daypartAnalyticsTable: !!tableCount.find(item => item === index + 1),
            };
            const isDisplayChartInPreview = (!!chartCount.find(item => item === index + 1) && (inpdf ? !isHiddenChart || isTableOnly : true));
            const reportDaypartSelector = _.get(daypartChartSelectors, [index]);
            const reportTypeSelector = _.get(reportDaypartSelector, 'type', typeSelector);
            const timeRangeSelector = _.get(reportDaypartSelector, 'timeRange');
            const reportCompilationChartData = _.get(chartData, [DAYPART_COMPILATION_CHART_ID, "data", timeRangeSelector]);
            const reportDaypartChartData = this.formattedChartData(reportTypeSelector, reportCompilationChartData);
            const key = chartCount[index] || tableCount[index] || (index + 1);
            if (inpdf) {
              // show table rows on full pdf page and add one more row if this page doesn't display the Grand Total row
              tableRowsPerPage =  25;
              // show fewer rows on the first page of adtype/station because of the chart above the table
              if (page === 0) {
                const numberRowOnFirstPage = rowOnFirstPage || MIN_LENGTH_DAYPART_DATA;
                tableRowsPerPage =  numberRowOnFirstPage + 1;
              }     
            }
            return (
              <div key={key} className={cx({[styles.detailsViewerMainView]: !isCustomReport}, styles.detailsViewer)}>
                <DaypartDetailsViewerComponent
                  dateRange={range}
                  chartData={reportDaypartChartData || daypartChartData}
                  daypartDetailSelector={reportDaypartSelector || daypartDetailSelector}
                  setChartSelector={this.handleSetChartSelector}
                  tableData={reportCompilationChartData || compilationChartData}
                  campaign={campaign}
                  onTableCellClick={this.handleTableCellClick}
                  inpdf={inpdf}
                  page={page}
                  numberPage={pageNumber}
                  rowsPerPage={tableRowsPerPage}
                  isGrandTotalDisplay={isGrandTotalDisplay}
                  isDaypartTab={isDaypartTab}
                  isCustomReport={isCustomReport}
                  isNewAdUsersEnabled={isNewAdUsersEnabled}
                  showInReportConfig={customShowInReportConfig}
                  countInReportConfig={countInReportConfig}
                  itemIndex={index}
                  tableSortSelector={tableSortSelector}
                  ga4CutOverDate={ga4CutOverDate}
                  showLocationDisclaimer={isInGA4Dates}
                  advertiser={advertiser}
                  isHiddenTable={isHiddenTable}
                  rowsFirstPage={rowOnFirstPage}
                  displayChart={isDisplayChartInPreview}
                />
              </div>
            )
          })}
         <ShowAllAds
            id={chartId}
            currentChartId={chartId}
            campaign={campaign}
            detailUrl={detailUrl}
            advertiser={advertiser}
            open={openDrillDown}
            onClose={this.handleCloseDrillDown}
            detailInfo={detailInfo}
            notifications={notifications}
            onAnalyzeMention={this.handleAnalyzeMention}
          />
        </div>
      )
  }
}

import { connect } from 'react-redux';
import { compose } from 'redux';
import getUrlApi from '../../../helpers/getUrlApi';
import { getEnabledFlags, checkEnableFeatureFlag } from '../../../helpers/common.js';
import { getNumberOfChartAndTableInReport } from '../Report/helper';
import { setReportChartSelector, setReportTableSortSelector } from '../../../state/modules/app/reportBuilder/actions';

function mapStateToProps(state, props) {
  const daypartChartSelectors =  props.daypartChartSelectors || _.get(state, ['reportBuilder', 'chartSelector', DAYPART_COMPILATION_CHART_ID], []);
  const chartSelector =  _.get(props.campaign, 'chartSelector', {});
  return {
    urlApi: getUrlApi(state),
    chartSelector,
    daypartChartSelectors,
    enabledFlags: getEnabledFlags(props, state),
  }
}
export default connect(
  mapStateToProps,
  dispatch => ({
    setChartSelector: compose(dispatch, setChartSelector),
    setReportChartSelector: compose(dispatch, setReportChartSelector),
    setReportTableSortSelector: compose(dispatch, setReportTableSortSelector),
  })
)(DaypartAnalytics);
